
import CryptoJS from "crypto-js";

const SECRET_KEY =
  "7465a35cc6aa865f856c9a5f8455bdff70317a2668d947a055eca64738549c35123";

export const encryptPayload = (payload) => {
  return CryptoJS.AES.encrypt(
    JSON.stringify({
      payload,
      timestamp: Date.now(),
    }),
    SECRET_KEY
  ).toString();
};